import { IconType, defaultProps } from './types';

/**
 * Icono CaretUp
 */
export const CaretUp = ({
  className,
  width,
  height,
  color = defaultProps.color,
}: IconType): JSX.Element => (
  <svg
    {...(className ? { className: className } : {})}
    {...(width ? { width: width } : {})}
    {...(height ? { height: height } : {})}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M16 14H8l4-5 4 5Z" fill={color} />
  </svg>
);
